import { createSlice, createAsyncThunk, } from '@reduxjs/toolkit';
import { CONS } from '@pomofocus/core';
import { getApiClient } from '../../utils/apiClient';
// Async thunks
// const fetchEnvConstants = createAsyncThunk(
//   'global/fetchEnvConstants',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await getApiClient()({
//         url: '/api/env-constants',
//         method: 'get',
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   },
// );
const sendErrorAlert = createAsyncThunk('global/sendErrorAlert', async (text, { rejectWithValue }) => {
    try {
        const response = await getApiClient()({
            url: '/api/error-message',
            method: 'post',
            data: { text },
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
// Initial state
const initialState = {
    bgColor: CONS.COLORS.THEME.pomodoro,
    visibleModal: null,
    textMessage: "",
    // rootUrl: undefined,
    // vapIdPublicKey: undefined,
    loading: false,
    error: null,
};
// Global slice
const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        // Change background color
        changeBgColor: (state, action) => {
            state.bgColor = action.payload.bgColor;
        },
        // Change visible modal
        changeVisibleModal: (state, action) => {
            state.visibleModal = action.payload.visibleModal;
            state.textMessage = action.payload.textMessage || "";
        },
        // Set root URL
        // setRootUrl: (
        //   state,
        //   action: PayloadAction<{ rootUrl: string }>,
        // ) => {
        //   state.rootUrl = action.payload.rootUrl;
        // },
        // Set VAPID public key
        // setVapIdPublicKey: (
        //   state,
        //   action: PayloadAction<{ vapIdPublicKey: string }>,
        // ) => {
        //   state.vapIdPublicKey = action.payload.vapIdPublicKey;
        // },
        // Set environment constants
        // setEnvConstants: (
        //   state,
        //   action: PayloadAction<{
        //     rootUrl: string;
        //     vapIdPublicKey: string;
        //   }>,
        // ) => {
        //   state.rootUrl = action.payload.rootUrl;
        //   state.vapIdPublicKey = action.payload.vapIdPublicKey;
        // },
        // Close modal
        closeModal: (state) => {
            state.visibleModal = null;
            state.textMessage = "";
        },
        // Open template selection modal (used by activity actions)
        openTemplateSelectionModal: (state) => {
            state.visibleModal = CONS.MODAL_TEMPLATE_SELECTION;
        },
        // Clear error
        clearError: (state) => {
            state.error = null;
        },
        // Reset global state
        resetGlobalState: () => initialState,
        // Utility actions for common modal types
        openConfigModal: (state) => {
            state.visibleModal = 'MODAL_CONFIG';
        },
        openReportModal: (state) => {
            state.visibleModal = 'MODAL_REPORT';
        },
        openProfileModal: (state) => {
            state.visibleModal = 'MODAL_PROFILE';
        },
        openUpgradeModal: (state) => {
            state.visibleModal = 'MODAL_UPGRADE';
        },
        openTodoListModal: (state) => {
            state.visibleModal = 'MODAL_TODO_LIST';
        },
    },
    extraReducers: (builder) => {
        // Fetch environment constants
        // builder
        //   .addCase(fetchEnvConstants.pending, (state) => {
        //     state.loading = true;
        //     state.error = null;
        //   })
        //   .addCase(fetchEnvConstants.fulfilled, (state) => {
        //     state.loading = false;
        //     // state.rootUrl = .payload.rootUrl;
        //     // state.vapIdPublicKey = action.payload.vapIdPublicKey;
        //     state.error = null;
        //   })
        //   .addCase(fetchEnvConstants.rejected, (state) => {
        //     state.loading = false;
        //   });
        // Send error alert (fire-and-forget, but we can track loading)
        builder
            .addCase(sendErrorAlert.pending, (state) => {
            state.error = null;
        })
            .addCase(sendErrorAlert.fulfilled, (state) => {
            state.error = null;
        })
            .addCase(sendErrorAlert.rejected, (state, action) => {
            state.error = action.payload;
        });
    },
});
// Export individual actions
const { changeBgColor, changeVisibleModal, 
// setRootUrl,
// setVapIdPublicKey,
// setEnvConstants,
closeModal, openTemplateSelectionModal, clearError, resetGlobalState, openConfigModal, openReportModal, openProfileModal, openUpgradeModal, openTodoListModal, } = globalSlice.actions;
// Selectors
const selectGlobalState = (state) => state.global;
const selectBgColor = (state) => state.global.bgColor;
const selectVisibleModal = (state) => state.global.visibleModal;
const selectTextMessage = (state) => state.global.textMessage;
// const selectRootUrl = (state: { global: GlobalState }) =>
//   state.global.rootUrl;
// const selectVapIdPublicKey = (state: { global: GlobalState }) =>
//   state.global.vapIdPublicKey;
const selectGlobalLoading = (state) => state.global.loading;
const selectGlobalError = (state) => state.global.error;
// Modal-specific selectors
const selectIsModalOpen = (modalType) => (state) => state.global.visibleModal === modalType;
const selectIsAnyModalOpen = (state) => state.global.visibleModal !== null;
// Environment selectors
// const selectIsEnvConfigured = (state: { global: GlobalState }) =>
//   Boolean(state.global.rootUrl && state.global.vapIdPublicKey);
// Grouped exports for better organization
export const globalActions = {
    ...globalSlice.actions,
    // Sync actions
    changeBgColor,
    changeVisibleModal,
    // setRootUrl,
    // setVapIdPublicKey,
    // setEnvConstants,
    closeModal,
    openTemplateSelectionModal,
    clearError,
    resetGlobalState,
    openConfigModal,
    openReportModal,
    openProfileModal,
    openUpgradeModal,
    openTodoListModal,
    // Async actions
    // fetchEnvConstants,
    sendErrorAlert,
};
export const globalSelectors = {
    selectGlobalState,
    selectBgColor,
    selectVisibleModal,
    selectTextMessage,
    // selectRootUrl,
    // selectVapIdPublicKey,
    selectGlobalLoading,
    selectGlobalError,
    selectIsModalOpen,
    selectIsAnyModalOpen,
    // selectIsEnvConfigured,
};
// Export reducer
export default globalSlice.reducer;
